import { Clock } from "lucide-react"
import { Badge } from "@/components/ui/badge"

export function CategoryBadge({ category }) {
  const styles = {
    professional: "bg-blue-100 text-blue-700 hover:bg-blue-100 border-blue-200",
    personal: "bg-green-100 text-green-700 hover:bg-green-100 border-green-200",
    spiritual: "bg-purple-100 text-purple-700 hover:bg-purple-100 border-purple-200",
  }

  const labels = {
    professional: "Professional",
    personal: "Personal",
    spiritual: "Spiritual",
  }

  return (
    <Badge className={styles[category] || styles.professional}>
      {labels[category] || category}
    </Badge>
  )
}

// Urgency is a 1-10 rating on both Crucial Conversations and Godly Council
// (Imperatives keep their own Low/Med/High enum and do NOT use this badge).
// Color bands: 1-3 zinc, 4-6 amber, 7-10 red.
export function UrgencyBadge({ urgency }) {
  if (urgency == null) return null

  const n = Number(urgency)
  const style =
    n <= 3
      ? "bg-zinc-100 text-zinc-600 hover:bg-zinc-100 border-zinc-200"
      : n <= 6
        ? "bg-amber-100 text-amber-700 hover:bg-amber-100 border-amber-200"
        : "bg-red-100 text-red-700 hover:bg-red-100 border-red-200"

  return <Badge className={style}>{n}/10</Badge>
}

// Task #426 coach review gate. Renders nothing for `posted` -- that's the
// norm, and a badge on every row would be noise. `pending_review` uses the
// softer member-portal amber tint (not the solid admin variant).
export function ReviewStatusBadge({ reviewStatus }) {
  if (reviewStatus !== "pending_review") return null

  return (
    <Badge className="bg-amber-100 text-amber-700 hover:bg-amber-100 border-amber-200">
      <Clock className="h-3 w-3 mr-1" />
      Awaiting Coach Review
    </Badge>
  )
}
